module.exports = __webpack_public_path__ + "static/media/sailing.6292088e.jpg";